import {
  Avatar,
  Divider,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
} from "@mui/material";
import { Settings, PersonAdd, Logout } from "@mui/icons-material";
import React, { FunctionComponent } from "react";
import styles from './styles/NavigationBar.css'
import { AppStore } from "../../AppStore";
import { Routes } from "../../App";
import { useHistory } from "react-router-dom";

interface Props {
  onLogout: () => void;
  onClose: () => void;
  onOpen: (event) => void;
  open: boolean;
  anchor: Element | ((element: Element) => Element) | null | undefined;
}

const ProfileMenu: FunctionComponent<Props> = (props) => {

  const [accountState] = AppStore.account.use()
  const abbreviatedUsername = accountState.user?.name[0]
  const history = useHistory();

  const toProfile = () => history.push(Routes.Profile);

  return (
    <>
      <IconButton onClick={props.onOpen} size="small" sx={{ ml: 2 }}>
        <Avatar sx={{ width: 32, height: 32 }}></Avatar>
      </IconButton>
      <Menu
        anchorEl={props.anchor}
        open={props.open}
        onClose={props.onClose}
        onClick={props.onClose}
        PaperProps={{className: styles.profileMenu}}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={toProfile}>
          <Avatar className={styles.Avatar} /> Profile
        </MenuItem>
        <Divider />
        <MenuItem onClick={props.onLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

export default ProfileMenu;
